import React from "react";
import styled from "styled-components";

export default function Path({ rolled }: any) {
  return (
    <div>
      <PathTitle>PATH</PathTitle>
      {rolled.map((r: string, i: number) =>
        i === 0 ? (
          <PathSpan key={i}>{r} </PathSpan>
        ) : (
          <PathSpan key={i}>+ {r} </PathSpan>
        ),
      )}
      <PathSpan>=</PathSpan>
      <PathSpan>
        {" "}
        {rolled.reduce((accumulator: number, element: string) => {
          return accumulator + +element;
        }, 0)}
      </PathSpan>
    </div>
  );
}

export const PathTitle = styled.h3`
  margin-bottom: 6;
  font-weight: 700;
  font-style: normal;
  line-height: 16px;
  font-size: 16px;
  color: #c7c7c7;
`;

export const PathSpan = styled.span`
  font-family: "GT America, regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
`;
